"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getSendNumber = getSendNumber;
exports.queryCustOrderList = queryCustOrderList;
exports.sendDelivery = sendDelivery;
exports.sendSelfPickup = sendSelfPickup;

var _request = _interopRequireDefault(require("@/utils/request"));

var _order = require("@/api/cms/order");

function getSendNumber() {
  return (0, _request.default)({
    url: 'api/send/number',
    method: 'get'
  });
}

function queryCustOrderList(params) {
  return (0, _order.queryCustOrderList)(params);
}

function sendDelivery(data) {
  return (0, _request.default)({
    url: 'api/send',
    method: data.id ? 'put' : 'post',
    data: data
  });
}

function sendSelfPickup(data) {
  return (0, _request.default)({
    url: 'api/send',
    method: data.id ? 'put' : 'post',
    data: data
  });
}

var _default = {
  getSendNumber: getSendNumber,
  queryCustOrderList: queryCustOrderList,
  sendDelivery: sendDelivery,
  sendSelfPickup: sendSelfPickup
};
exports.default = _default;